import styled from 'styled-components';
import { Card } from 'antd';

export const ParticipantsContainer = styled.div`
  padding: 24px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 
    0 1px 3px rgba(0, 0, 0, 0.06),
    0 2px 6px rgba(0, 0, 0, 0.04);
  border: 1px solid #e8e8e8;
`;

export const FiltersContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

export const SidebarContainer = styled.div`
  width: 300px;
  min-width: 300px;
  max-width: 300px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;
`;

export const ClubCard = styled(Card)<{ selected?: boolean }>`
  cursor: pointer;
  transition: all 0.3s ease;
  border: ${props => props.selected ? '2px solid #1890ff' : '1px solid #e8e8e8'};
  background: ${props => props.selected ? '#f0f7ff' : '#ffffff'};
  
  &:hover {
    border-color: #1890ff;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15);
  }
  
  .ant-card-body {
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const MainContentContainer = styled.div`
  flex: 1;
  min-width: 0;
`;

